import { AddressTypeEnum } from "@lib/enum"
import dayjs from "dayjs"

export class FloorStaffModel {
  id: any
  constructor() {
    this.id = undefined
  }

  public static assign(obj) {
    if (!obj) return undefined

    const newObj = Object.assign(new FloorStaffModel(), obj)

    newObj.birthDate = obj.birthDate ? dayjs(obj.birthDate) : null
    newObj.currentAddress = obj.customerAddresses?.find(
      (item) => item.addressType === AddressTypeEnum.CURRENT
    )
    newObj.permanentAddress = obj.customerAddresses?.find(
      (item) => item.addressType === AddressTypeEnum.PERMANENT
    )

    return newObj
  }

  public static assigns<T>(objs) {
    const results: any[] = []
    objs?.forEach((item) => results.push(this.assign(item)))
    return results
  }
}
